<template>
  <div class="quantity-wrapper">
    <div class="quantity-left">
      <p class="quantity-title">{{title1}}</p>
      <div class="chart-box" ref="chart1"></div>
    </div>

    <div class="quantity-right ">
      <p class="quantity-title">{{title2}}</p>
      <div class="chart-box" ref="chart2"></div>
    </div>
  </div>
</template>

<script>
  import {echartsMixin} from 'assets/js/common/mixin.js'

  export default {
    name: "quantity",
    mixins: [echartsMixin],
    component: {},
    data() {
      return {
        title1: '各类型土地流转数量类型',
        title2: '各类型土地流转面积占比分析',
        chart1: '',
        chart2: '',
        ageORsexData: {
          age: ["耕地", "园地", "林地", "牧草地", "养殖用地"],
          man: ["12", "10", "9", "6", "22", "42"],
        },
        areaRatioData: [
          {name: "养殖用地", value: "19"},
          {name: "耕地", value: "31"},
          {name: "园地", value: "16"},
          {name: "林地", value: "7"},
          {name: "牧草地", value: "27"},
        ]
      }
    },
    mounted() {
      this.chart1 = this.$echarts.init(this.$refs.chart1)
      this.chart2 = this.$echarts.init(this.$refs.chart2)
      this.initOption()
    },
    methods: {
      initOption() {
        let option1 = {
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              width: "30%",
              type: 'shadow',
              shadowStyle: {
                color: "rgba(8,104,98,0.36)"
              }
            },
            backgroundColor: "#002624",
            borderColor: '#009288',
            borderWidth: 1,
            textStyle: {
              color: "#fff",
            },
            formatter: (params) => {
              let html = "<div style='text-align:center;padding:15px'>" + params[0].name + "<br/>"
              html += `${params[0].seriesName}：<span style="color:#4CD5FF">${params[0].data}</span>`
              return html + '</div>'
            }
          },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '9%',
            top: "14%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.ageORsexData.age,
            boundaryGap: true, //坐标轴的留白
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0C615B",
              }
            },
            axisTick: {
              show: false //坐标轴刻度
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              textStyle: {},
            },

          },
          yAxis: {
            type: 'value',
            name: '                 流转数量（千公顷）',
            nameTextStyle: {
              color: "#fff"
            },
            axisTick: {
//							show: false //坐标轴刻度
            },
            axisLine: {
              show: false
            },
            axisLabel: {
//							show: false,
              color: "#fff"
            },
            splitLine: {
              lineStyle: {
                color: '#0C615B',
                type: "solid",

              }
            },
          },
          series: {
            name: '流转数量',
            type: 'bar',
            barWidth: 20,
            barCategoryGap: "50%",
            showSymbol: false,
            smooth: true,
            itemStyle: {
              normal: {
                color: "rgba(24,95,109,0.75)",
                borderColor: "rgba(0,255,203,0.55)"
              },
            },
            data: this.ageORsexData.man
          },
        }
        let option2 = {
          tooltip: {
            trigger: 'item', //图形触发，axis是类目周触发
            axisPointer: {
              type: 'line',
              shadowStyle: {
                color: 'rgba(0, 255, 102, .05)'
              }
            },
            backgroundColor: "#002624",
            borderColor: '#009288',
            borderWidth: 1,
            formatter: (params) => {
              let html = "<div style='text-align:center;padding:15px'>" + params.name + "<br/>"
              html += `${params.marker}${params.name}：<span style="color:#4CD5FF">${params.value}</span>`
              return html + '</div>'
            },
          },
          title: {
            text: [],
            top: "0",
            x: "center",
//              left: "34.5%",
            textStyle: {
              fontSize: 22,
              fontWeight: "normal",
              color: "#fff"
            }
          },
          grid: {
            top: "20",
            bottom: '20'
          },

          series: [
            {
              color: ["#F79017", "#31BEA8", "#32A1EC", "#E0D25A", "#EAAD42"],
              type: 'pie',
              radius: ['12%', '44%'],
              center: ['50%', '50%'],
              avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  borderColor: '#042546',
                  borderWidth: 2,
                },
              },
              labelLine: {
                length: 70,
              },
              label: {
                formatter: (params) => {
                  return `${params.name}\n${params.percent}%`
                }
              },
              data: this.areaRatioData
            }
          ],

        }
        this.chart1.setOption(option1)
        this.chart2.setOption(option2)
      },
      _resizeHanlder() {
        this.chart1.resize()
        this.chart2.resize()
      },
      _destroyHandler() {
        if (this.chart1) {
          this.chart1.dispose()
        }
        if (this.chart1) {
          this.chart2.dispose()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .quantity-wrapper {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .quantity-left {
      width: calc(60% - 20px);
      height: 100%;
      border: 1px solid #03887F;
      background-color: #002624;
      box-sizing: border-box;
      .chart-box {
        height: calc(100% - 30px);
      }
    }
    .quantity-right {
      width: 40%;
      height: 100%;
      border: 1px solid #03887F;
      background-color: #002624;
      box-sizing: border-box;
      .chart-box {
        height: calc(100% - 30px);
      }
    }
    .quantity-title {
      height: 30px;
      line-height: 30px;
      padding-left: 15px;
      background: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/transaction/quantity.vue